<template>
  <div id="notFound" class="notFound">
    <Header />
    <div id="header-navi" class="header-navi">
      <h2 class="header-navi__ttl">404 Not found</h2>
    </div>
    <div class="notFound__main">
      <p>ページが見つかりません</p>
    </div>
   <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  components: {
    Header,
    Footer
  }
}
</script>

<style lang="scss" scoped>
.header-navi {
  @include customTitle;
}
.notFound {
  &__main {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/NotFound.vue